(function($) {

    'use strict'

	var stdCarousel = function() {
		$('.standard-carousel').owlCarousel({
			items: 1,
			loop: true,
			center: true,
			nav: true,
			autoHeight: true,
			smartSpeed: 600,
			navText: [
				"",
				""
			],
		})
	};

	var initCarousel = function() {
		stdCarousel();
	}

	$(document).ready(function() {
		if($('div').hasClass('standard-carousel')) {
			initCarousel()
		}
	})

})(jQuery)